import { render, staticRenderFns } from "./EventTabs.vue?vue&type=template&id=7c526ec1&scoped=true"
import script from "./EventTabs.vue?vue&type=script&lang=js"
export * from "./EventTabs.vue?vue&type=script&lang=js"
import style0 from "./EventTabs.vue?vue&type=style&index=0&id=7c526ec1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c526ec1",
  null
  
)

export default component.exports